export default "/images/vendor/flag-icon-css/flags/4x3/ru.svg?f1c2ba49b3ccc06ba58a3889e1445971";